import { SCORING_PRIORITIES } from "../../leads/types/lead-priority";
import type { TeamLeadScoringCriteria } from "../types/team-list-item";

/** How many scoring rules a team has across all priorities. */
export const countTeamScoringRules = (criteria: TeamLeadScoringCriteria | undefined): number =>
    SCORING_PRIORITIES.reduce((total, priority) => total + (criteria?.rules[priority]?.length ?? 0), 0);
